import React from "react";

import cx from "../ui/cx";
import { sourceLabel } from "../../static/vmcLine";
import { VmcSource } from "../../types/vmcOrder";

type Props = {
  source: VmcSource | undefined;
  className?: string;
};

// The kind of pieces a VMC line takes, "ટર્નિંગ તૈયાર" or "કટીંગ તૈયાર", as a chip like the receive rows' "ઓર્ડર #N".
const VmcSourceChip = ({ source, className }: Props) => (
  <span
    className={cx(
      "rounded bg-[#113F67]/10 px-1.5 py-0.5 text-xs font-semibold text-[#113F67]",
      className
    )}
  >
    {sourceLabel(source)}
  </span>
);

export default VmcSourceChip;
